module.exports = __webpack_public_path__ + "static/media/csa.1004ad75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/csa.jpg
// module id = 96
// module chunks = 0